import { Button, Color, Flex, Text } from "src/elements";
import { pages } from "src/utils";
import { useNavigation } from "src/utils/navigation";

const Page403 = () => {
  const { navigate } = useNavigation();

  return (
    <Flex height="100vh" column justify="center" align="center" gap="20px" padding="50px" flexGrow>
      <Text variant="h2" color={Color.textSecondary}>
        403 - Access Denied
      </Text>

      <Text color={Color.textSecondary}>You don't have permission to view this page.</Text>

      <Button onClick={() => navigate(pages.home)} width="200px">
        Back to Home
      </Button>
    </Flex>
  );
};

export default Page403;
